import React from 'react'
import Page from '../components/Page'
import BlogFull from '../components/BlogFull'

export default function BlogTemplate(props) {
  const { excerpt, frontmatter, html } = props.data.markdownRemark
  const { title } = frontmatter
  const banner = frontmatter.banner ? frontmatter.banner.publicURL : null
  return (
    <Page title={title} description={excerpt} image={banner}>
      <BlogFull
        title={title}
        date={frontmatter.date}
        banner={banner}
        html={html}
      />
    </Page>
  )
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      id
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
        banner {
          publicURL
        }
      }
      excerpt
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog.js